import React from 'react';
import Alert from './Alert.js';

function Form({
  submitHandler,
  setName,
  name,
  setCategory,
  category,
  showAlert,
  todos,
  alert,
  status,
  setStatus,
}) {
  return (
    <form className="grocery-form">
      {alert.show && <Alert {...alert} showAlert={showAlert} todos={todos} />}
     <h2>grocery buddy</h2>
      <div className="form-control">
        <input
          type="text"
          onChange={(e) => setName(e.target.value)}
          value={name}
        />
        <label htmlFor="category">Category</label>
        <select
          name="category"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
        >
          <option value="food">Food</option>
          <option value="drink">Drink</option>
          <option value="clothes">Clothes</option>
          <option value="entertainment">Entertainment</option>
        </select>
        <button type="submit" className="glow-on-hover" onClick={submitHandler}>
          add
        </button>
      </div>
      <div className="form-control">
        <label htmlFor="filter">Filter</label>
        <select
          name="filter"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <option value="food">Food</option>
          <option value="drink">Drink</option>
          <option value="clothes">Clothes</option>
          <option value="entertainment">Entertainment</option>
          <option value="completed">Completed</option>
          <option value="incompleted">Incompleted</option>
          <option value="all">All</option>
        </select>
      </div>
    </form>
  );
}

export default Form;
